import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from 'components/Button/Button';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import appHelpers from 'utils/app-urls';
import messages from '../messages';

const cdnURL = appHelpers.getCDNUrl();

export const Route = createFileRoute('/auth/reset-password/completed')({
  component: PasswordUpdated,
});

export default function PasswordUpdated() {
  const navigate = useNavigate();

  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const passwordUpdatedMessages = messages[language].passwordUpdated;

  function toDashboard() {
    navigate({ to: '/' });
  }

  return (
    <div className="bg-background pt-6 pb-6 duration-500 ease-in-out transition-colors">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <img
          src={`${cdnURL}assets/register/thumbs-up.png`}
          alt={passwordUpdatedMessages.wellDoneAlt}
          className="mt-4 mb-6 center"
        />
        <h2 className="font-semibold leading-9 m-6 text-2xl header-text text-center duration-500 ease-in-out transition-colors">
          {passwordUpdatedMessages.heading}
        </h2>
        <p className="text-body-text duration-500 ease-in-out transition-colors">
          {passwordUpdatedMessages.body}
        </p>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md pt-10">
          <span className="block w-full rounded-md">
            <Button
              onClick={toDashboard}
              w-full
              flex
              justify-center
              py-2
              px-4
              border
              border-transparent
              text-sm
              font-normal
              rounded-md
              text-white
              transition
              duration-150
              ease-in-out
              bg-primary
              small>
              {passwordUpdatedMessages.continueButton}
            </Button>
          </span>
        </div>
      </div>
    </div>
  );
}
